import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import InputDate from "../../helpers/InputDate";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import InputDownloader from "../../helpers/InputDownloader";
import InvoiceForm from "./InvoiceForm";
import InvoiceApprove from "./InvoiceApprove";
import InvoiceSend from "./InvoiceSend";
import InvoicePrint from "./InvoicePrint";
import PackToZip from "../../helpers/PackToZip";
import InvoicePrepere from "./InvoicePrepere";
import InvoiceTempDel from "./InvoiceTempDel";
import CalculateReview from "./CalculateReview";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import FilterMemory from "../../helpers/FilterMemory";
import InvoiceRaport from "./InvoiceRaport";
import InvoiceKSeF from "./InvoiceKSeF";


function Invoices(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [services, setServices] = useState([]);
    


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;


    const [clientsCombo, setClientsCombo] = useState(null);
    const [selectedId, setSelectedId ] = useState(defId);
    const [selectedPhrase, setSelectedPhrase ] = useState("");
    const [fraza, setFraza ] = useState("");
    const refSearch = useRef();


    var dt = new Date();
    dt = dt.toLocaleDateString('en-CA');
    dt = "" + dt.substring(0,7) + "-01";
 
    var defLimit = 200;
    if(props.fak_kontrahenci_id != undefined) 
    {
        defLimit = 20;
        dt = '';
    }
    
    

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({ 
     

        fak_kontrahenci_id:  defId,   

        numer_dokumentu:   props.mainView.readFilter('inv_numer_dokumentu',''),   
        data_wystawienia_od:  props.mainView.readFilter('inv_data_wystawienia_od',   dt),   
        data_wystawienia_do:  props.mainView.readFilter('inv_data_wystawienia_do',''),   
        do_zaplaty_od:        props.mainView.readFilter('inv_do_zaplaty_od',''),   
        do_zaplaty_do:        props.mainView.readFilter('inv_do_zaplaty_do',''),   
        kwota_rozliczenia_od: props.mainView.readFilter('inv_kwota_rozliczenia_od',''),   
        kwota_rozliczenia_do: props.mainView.readFilter('inv_kwota_rozliczenia_do',''),   
        status: props.mainView.readFilter('inv_status','_x_'),   
        status_rozliczenia: props.mainView.readFilter('inv_status_rozliczenia','_x_'),   

        ksef_wyslano: props.mainView.readFilter('inv_ksef_wyslano','_x_'),   
        ksef_numer: props.mainView.readFilter('inv_ksef_numer',''),   


        termin_platnosci_od:  props.mainView.readFilter('inv_termin_platnosci_od',   ''),   
        termin_platnosci_do:  props.mainView.readFilter('inv_termin_platnosci_do',''),   

        wys_powiadomienie_email: props.mainView.readFilter('inv_wys_powiadomienie_email','_x_'),   
        wys_powiadomienie_sms: props.mainView.readFilter('inv_wys_powiadomienie_sms','_x_'),   

        efaktura:  props.mainView.readFilter('inv_efaktura','_x_'),  

        korekta: props.mainView.readFilter('inv_korekta','_x_'),   

        nazwa:  props.mainView.readFilter('inv_nazwa',''),   
        nip:  props.mainView.readFilter('inv_nip',''),     

        sl_typ_uslugi_id:  props.mainView.readFilter('inv_sl_typ_uslugi_id',''),   

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: defLimit,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [selectedRow, setSelectedRow] = useState([]);


       const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);
 

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_show5',
            title: 'dokument opłacony',
           filter: {  filed: "status_rozliczenia", set: "1", typ: "combo"  },
        },
        {
            cls:'color_show4',
            title: 'wygenerowany - fakturowanie wstrzymane',
           filter: {  filed: "status", set: "10", typ: "combo"  },
        },
        {
            cls:'color_deleted2',
            title: 'dokument po terminie',
           filter: {  filed: "status_rozliczenia", set: "4", typ: "combo"  },
        },
        {
            cls:'color_deleted',
            title: 'dokument anulowany',
           filter: {  filed: "status", set: "2", typ: "combo"  },
        },
        {
            cls:'color_show3',
            title: 'niezatwierdzony',
           filter: {  filed: "status", set: "0", typ: "combo"  },
        },
    ]);


        const listenerSelectedId = (filedName, val, correct, msg) => 
        {
            setSelectedId(val);
        }

        const listenerSelectedPhrase = (filedName, val, correct, msg) => 
        {
            setSelectedPhrase(val);
        }

        const listenerFraza = (filedName, val, correct, msg) => 
        {
            setFraza(val);
        }




        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const changeDateX = (h) => {

            function getDaysInMonth(m, y) {
                   return m===2 ? y & 3 || !(y%25) && y & 15 ? 28 : 29 : 30 + (m+(m>>3)&1);
            }

            var t = h.target.getAttribute('atr-dt');
             
            if(t == '-m')
            {
                let dt = new Date( new Date().setMonth(new Date().getMonth() - 1) );                

                var last = getDaysInMonth( dt.getMonth()+1, dt.getFullYear()  );

                console.log('Date', dt,  dt.getMonth()+1, dt.getFullYear()  );
            
                dt = dt.toLocaleDateString('en-CA');
                dt = "" + dt.substring(0,7) + "-01";
                last  = "" + dt.substring(0,7) + "-" + last;
                console.log(dt, last);

                setFilterParam( {...filterParam, ["data_wystawienia_od"]:dt,  ["data_wystawienia_od_valid"]:true, ["data_wystawienia_do"]:last,  ["data_wystawienia_do_valid"]:true,     } );                   
 
            }

            if(t == '+m')
            {
                let dt = new Date( new Date().setMonth(new Date().getMonth() + 1) );
                //console.log('Date', dt);

                var last = getDaysInMonth( dt.getMonth()+1, dt.getFullYear()  );

                console.log('Date', dt,  dt.getMonth()+1, dt.getFullYear()  );

                dt = dt.toLocaleDateString('en-CA');
                dt = "" + dt.substring(0,7) + "-01";
                last  = "" + dt.substring(0,7) + "-" + last;
                console.log(dt, last);

                setFilterParam( {...filterParam, ["data_wystawienia_od"]:dt,  ["data_wystawienia_od_valid"]:true, ["data_wystawienia_do"]:last,  ["data_wystawienia_do_valid"]:true,     } ); 
            }

            //var dt = new Date();
            //dt = dt.toLocaleDateString('en-CA');
            //dt = "" + dt.substring(0,7) + "-01";


                    var defTimeOut = 500;            
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );

        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('inv_numer_dokumentu', '');
            props.mainView.writeFilter('inv_data_wystawienia_od',  dt );
            props.mainView.writeFilter('inv_data_wystawienia_do', '');
            props.mainView.writeFilter('inv_do_zaplaty_od', '');
            props.mainView.writeFilter('inv_do_zaplaty_do', '');
            props.mainView.writeFilter('inv_kwota_rozliczenia_od', '');
            props.mainView.writeFilter('inv_kwota_rozliczenia_do', '');
            props.mainView.writeFilter('inv_nazwa', '');
            props.mainView.writeFilter('inv_nip', ''); 
            props.mainView.writeFilter('inv_sl_typ_uslugi_id', ''); 
            props.mainView.writeFilter('inv_status', '_x_'); 
            props.mainView.writeFilter('inv_korekta', '_x_'); 

            props.mainView.writeFilter('inv_ksef_wyslano', '_x_'); 
            props.mainView.writeFilter('inv_ksef_numer', ''); 

            props.mainView.writeFilter('inv_wys_powiadomienie_email', '_x_'); 
            props.mainView.writeFilter('inv_wys_powiadomienie_sms', '_x_'); 

            props.mainView.writeFilter('inv_termin_platnosci_od', ''); 
            props.mainView.writeFilter('inv_termin_platnosci_do', ''); 

            props.mainView.writeFilter('inv_efaktura', '_x_'); 
           

            var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            setFilterParam({

                fak_kontrahenci_id:  defId,  

                numer_dokumentu: '',                 
                data_wystawienia_od: dt,                 
                data_wystawienia_do: '',                 
                do_zaplaty_od: '',                 
                do_zaplaty_do: '',                 
                kwota_rozliczenia_od: '',                 
                kwota_rozliczenia_do: '',                 
                nazwa: '',                 
                nip: '',                 
                sl_typ_uslugi_id: '',
                status: '_x_',
                status_rozliczenia: '_x_',
                korekta: '_x_',

                ksef_wyslano: '_x_',
                ksef_numer: '',

                termin_platnosci_od: '',
                termin_platnosci_do: '',

                efaktura: '_x_',

                wys_powiadomienie_email: '_x_',
                wys_powiadomienie_sms: '_x_',
                          
                
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 200,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }

         const filterApproveMemory = (filter) => {   

                    setFilterParam(filter);               
                    var defTimeOut = 100;                 
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );         
        }


        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }



       const getClientsCombo = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,clients_combo', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setClientsCombo(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }

    const getTServices = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,t_services', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setServices(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }


    const getTab = ( ) => {
        

     

        fetch( Config.url + '/rest_v1_calc,invoices', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             


                    var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.numer_dokumentu  + ", " + item.data_wystawienia + ", " + item.klient.nazwa,
                                numer_dokumentu:  item.numer_dokumentu ,
                                data_wystawienia:  item.data_wystawienia ,
                                klient:  item.klient.nazwa ,
                                do_zaplaty:  item.do_zaplaty ,
                                zatwierdzona: item.zatwierdzona,
                                anulowana: item.anulowana,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             

 


                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }




   

    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const quickFilter = (e ) => {
            var field = e.target.getAttribute('field');
            var value = e.target.getAttribute('value');                    

            setFilterParam(  {...filterParam, [field]:value } );
            setTab(null);
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab(null);
    }

    
    const goDownload = (e) => {

         var id = e.target.getAttribute('atr-id');
         var title = e.target.getAttribute('atr-title');

         var fileName = title.replace(/[/]/g,"_") + ".pdf";

         var links = [
            {
                link: '/rest_v1_calc,pdf',
                typ: 'pdf',
                fileName:  fileName,
                params: {
                    id: id
                },
            }
         ];

         if(Config.env == 'dev') console.log("goDownload", id, title);
         props.mainView.downloadDialog(links);
    }


    const goCreateInvoice = () => {

            setView({v:'list',id:-1});


            if( selectedId != '_x_' && selectedId > 0 )
            {
            
                    //----------------------------------------------------------------------
                    //----------------------------------------------------------------------
                
                        props.mainView.showProgress();       
                    

                            fetch( Config.url + '/rest_v1_calc,invoice_create', {
                                method: 'POST', 
                                body: JSON.stringify({
                                    fak_kontrahenci_id: selectedId,
                                }), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 

                                    props.mainView.hideProgress();    

                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                        }else    
                                        {
                                            if(res.status == 'OK')         
                                            {       
                                                setTab(null);//pobierz na nowo                                    

                                                props.mainView.showDialog( "Sukces", "Szablon dokumentu został utworzony (id: "+ parseInt( res.result) +"). Enter - by przejść dalej." , "ok" ,  (resx)=>{                                                                                                                                                              

                                                    
                                                      setView({...view, ["v"]:"review", ["id"]:  res.result  });
                                                } );  

                                            }else 
                                            {
                                                  props.mainView.showDialog( "Ups!", "Nie można utworzyć dokumentu " + res.result , "error" , null);
                                            }
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                    props.mainView.hideProgress();    
                            });

                    //----------------------------------------------------------------------
                    //----------------------------------------------------------------------


            }else 
            {
                    props.mainView.showDialog( "Ups!", "Wybierz jedną firmę z listy" , "error" , null);
            }
    }



    const removeInvoice = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć pusty dokument ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,invoice_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Pusty dokument został usunięty"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można usunać dokumentu " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }


    const removeInvoiceZ = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz cofnąć wystawienie faktury ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,invoice_back', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Dokument został anulowany"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można anulować dokumentu " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }

    


     const goInvoiceKor = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz wystawić korektę dla ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,invoice_kor', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        getTab();
                                                        props.mainView.showDialog( "Sukces", "Szablon korekty został utworzony"  , "ok" , (resp) => {
                                                              setView({v:"review", id: res.result });  
                                                        } );

                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można utworzyć korekty " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }


    
   const goAgain = (e) => {

        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz utworzyć podobną fakturę ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,invoice_again', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        getTab();
                                                        props.mainView.showDialog( "Sukces", "Szablon faktury gotowy do edycji"  , "ok" , (resp) => {
                                                              setView({v:"review", id: res.result });  
                                                        } );

                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie można utworzyć korekty " + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


    }


    const scaleDocs = () => {

         props.mainView.showProgress();

        var req = {
                          
        }



        fetch( Config.master + '/rest_v1_calc,invoice_scale', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => {   });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => {   } );  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                            getTab();   
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę. (' + JSON.stringify(res.result) + ')' , "error" ,  (resp) => {  });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { } );
                   props.mainView.hideProgress();
         });
                   

         return false;

    }



//-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------

  const goZip = () => {

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if(   selectedRow[k].selected == 1)
               {
                  console.log("Logx",  selectedRow[k]);
                  if(selectedRow[k].zatwierdzona == 1  )
                  {                    
                        ids.push({
                            //id: selectedRow[k].id,
                            typ_id: selectedRow[k].id,
                            typ: 'faktura',
                            title: selectedRow[k].title
                        });
                  }                   
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog("Ups" , 'Nie wybrano żadnego wystawionego dokumentu' ,  "error"  ,null); 
            return;              
         }

         setView({
            v: 'zip',
            id: -1,
            param: ids, //id plików..
         });
    }   

//-------------------------------------------------------
//-------------------------------------------------------
//-------------------------------------------------------











   const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && view.v == "new" )                                                  
                        {
                                setView({v:'list',id:-1});
                        }else 
                        if(  code == 13 && view.v == "new" )                                                  
                        {                              
                                goCreateInvoice();
                        }else   
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {                            
                                e.target.blur();
                                filterClear();
                        }else                                                  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }


   }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Invoices.js, listener on");
            window.onkeydown = keyListener;                      
            
            return () => {   
                 if(Config.env == "dev") console.log("Invoices.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });            
        setTab(null); 
        setClientsCombo(null);
    }



    if(tab == null)
    {
        setTab([]);
        getTab();     
        getClientsCombo();
        getTServices();
        return <div>
            ...
        </div>
    }


    document.title = "Faktury";


    if(view.v == "review")
    {
 
        return <InvoiceForm  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={view.id}  goDownload={goDownload} />
    }

    if(view.v == "calc")
    {
 
        return <CalculateReview  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={view.id}   />
    }


    var tmpView = null;
    if(view.v == 'zip')
    {
        tmpView = <PackToZip userData={props.userData} mainView={props.mainView} tab={view.param}   onClose={onBack} onSuccess={onSuccess}   />
    }


  


    var dialogSelect = null;
    if(view.v == "new")
    {
        var clientFiltered = clientsCombo; 
        var selectedOneId = -1;

        if(selectedPhrase.length > 2 )
        {
            clientFiltered = new Array();

            for(var kx=0; kx < clientsCombo.length; kx++)
            {      
                if( clientsCombo[kx].title.toLowerCase().includes( selectedPhrase.toLocaleLowerCase() ) )
                {
                    clientFiltered.push(  clientsCombo[kx] );
                    selectedOneId = clientsCombo[kx].v;
                }
            }
        }

        if(clientFiltered.length == 1) {
           if(selectedId != selectedOneId)  setSelectedId(selectedOneId);
        }


        dialogSelect =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz klienta</div>
                        <div className="dlg_msg" >

                   
                        <InputText   userData={props.userData} value={selectedPhrase}   valChange={listenerSelectedPhrase} goNext={goNextNew} name="phrase" placeholder={"Nazwa / NIP: "}  className=' w250 '  />
                                          
                        <InputCombo items={clientFiltered}  value={selectedId} err={null}  valChange={listenerSelectedId} goNext={null}   name={"selectedId"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                            
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={goCreateInvoice}>utwórz dokument [enter]</div>
                        </div>
        </div>
 
    }
    

 
        var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "data_wystawienia", name: "Data wystawienia"  },         
        {column: "do_zaplaty", name: "Do zapłaty"  },         
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
        ]


    var sumNetto     = 0.0;    
    var sumVat       = 0.0;    
    var sumBrutto    = 0.0;    
    var sumDoZaplaty = 0.0;    
    var sumRozliczonych = 0.0;    

    for(var k=0; k < tab.length; k++)
    {
          sumNetto         = parseFloat(sumNetto) + parseFloat (tab[k].razem_netto );
          sumVat           = parseFloat(sumVat) + parseFloat (tab[k].razem_vat );
          sumBrutto        = parseFloat(sumBrutto) + parseFloat (tab[k].razem_brutto );
          sumDoZaplaty     = parseFloat(sumDoZaplaty) + parseFloat (tab[k].do_zaplaty );
          sumRozliczonych  = parseFloat(sumRozliczonych) + parseFloat (tab[k].kwota_rozliczenia );
    }




    var zaznaczonych = 0;
    var arrSelected = new Array();    
    var arrSelectedToApprove = new Array();    
    var arrSelectedApproved = new Array();    
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) 
        {
            zaznaczonych ++;
            arrSelected.push( selectedRow[s] );

            
            if( ( selectedRow[s].zatwierdzona == 0 || selectedRow[s].zatwierdzona == -10 ) && selectedRow[s].anulowana == 0 )
            {
               arrSelectedToApprove.push( selectedRow[s] );
            }

            if(selectedRow[s].zatwierdzona == 1 && selectedRow[s].anulowana == 0 )
            {
               arrSelectedApproved.push( selectedRow[s] );
            }
           
        }
    }

 

    var titleRaport = "Faktury";

    if(filterParam.data_wystawienia_od.length > 2)
    {
        titleRaport += ", od dnia: " + filterParam.data_wystawienia_od;
    }

    if(filterParam.data_wystawienia_do.length > 2)
    {
        titleRaport += ", do dnia: " + filterParam.data_wystawienia_do;
    }

    
    

    return  <div className="view_content">

            

                <h3 className="dash_header">Faktury</h3>

    
               <div className="table_filter">


                   


                         {
                             filterParam.fak_kontrahenci_id < 1 &&
                             <Fragment>

                                   <FilterMemory userData={props.userData} mainView={props.mainView}  uq="faktury"  filterParam={filterParam} filterApproveMemory={filterApproveMemory} />

                                   <div className="filter_controll">   
                                            <label>Nazwa: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />                                            
                                    </div> 

                                    <div className="filter_controll">   
                                            <label>NIP: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"NIP: "}   />
                                    </div> 
                                   

                                    <div className="filter_controll">   
                                            <label>Typ klient: </label>                             
                                            <InputCombo items={services}   userData={props.userData} value={filterParam.sl_typ_uslugi_id}   valChange={valChangeListener} goNext={goNextNew} name="sl_typ_uslugi_id" placeholder={": "}   />
                                    </div> 

                             </Fragment>
                         }   

                        
 
 
                        <div className="filter_controll">   
                                <label>Status: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'0', title: 'Niezatwierdzony'}, {v:'1', title: 'Zatwierdzony'},  {v:'2', title: 'Anulowana'},    {v:'-10', title: 'Wygenerowana, fakt. wstrzymane'},       ] }   userData={props.userData} value={filterParam.status}   valChange={valChangeListener} goNext={goNextNew} name="status" placeholder={": "}   />
                        </div> 

                        <div className="filter_controll">   
                                <label>Numer dokumentu: </label>                             
                                <InputText   userData={props.userData} value={filterParam.numer_dokumentu}   valChange={valChangeListener} goNext={goNextNew} name="numer_dokumentu" placeholder={"Nazwa: "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Numer KSeF: </label>                             
                                <InputText   userData={props.userData} value={filterParam.ksef_numer}   valChange={valChangeListener} goNext={goNextNew} name="ksef_numer" placeholder={"Numer KSeF: "}   />
                        </div> 

                          <div className="filter_controll">   
                                <label>Wysłano do KSeF: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'0', title: 'Nie'}, {v:'1', title: 'Tak'}   ] }   userData={props.userData} value={filterParam.ksef_wyslano}   valChange={valChangeListener} goNext={goNextNew} name="ksef_wyslano" placeholder={": "}   />
                        </div> 
 
                        <div className="filter_controll filter_merge">   
                                <label>Data wystawienia (od dnia / do dnia): &nbsp; <sup className="link_color" atr-dt="-m" onClick={changeDateX} >[-m]</sup>  &nbsp; <sup className="link_color" atr-dt="+m" onClick={changeDateX} >[+m]</sup>   </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_do" placeholder={"Do dnia: "}   />
                        </div> 

                        <div className="filter_controll filter_merge">   
                                <label>Termin płatności (od dnia / do dnia): &nbsp; <sup className="link_color" atr-dt="-m" onClick={changeDateX} >[-m]</sup>  &nbsp; <sup className="link_color" atr-dt="+m" onClick={changeDateX} >[+m]</sup>   </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.termin_platnosci_od}   valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.termin_platnosci_do}   valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci_do" placeholder={"Do dnia: "}   />
                        </div> 



                        
                        <div className="filter_controll filter_merge">   
                            <label>Do zapłaty (od / do): </label>        
                            <br/>                     
                            <InputDecimal userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_od}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_od" placeholder={" "}   />
                            <InputDecimal  userData={props.userData}  mainView={props.mainView}  value={filterParam.do_zaplaty_do}   valChange={valChangeListener} goNext={goNextNew} name="do_zaplaty_do" placeholder={" "}   />
                        </div> 

                        <div className="filter_controll filter_merge">   
                            <label>Kwota rozliczenia (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_do" placeholder={" "}   />
                        </div>

                        


                        <div className="filter_controll">   
                                <label>Płatność: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'1', title: 'Rozliczony w całości'}, {v:'2', title: 'Rozliczona częściowo'},  {v:'3', title: 'Nie zapłacono nic'},   {v:'4', title: 'Nie zapłacono nic - po terminie'},      ] }   userData={props.userData} value={filterParam.status_rozliczenia}   valChange={valChangeListener} goNext={goNextNew} name="status_rozliczenia" placeholder={": "}   />
                        </div> 

                         <div className="filter_controll">   
                                <label>Korekta: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'1', title: 'Pokaż tylko korekty'}, {v:'2', title: 'Nie pokazuj korekt'}    ] }   userData={props.userData} value={filterParam.korekta}   valChange={valChangeListener} goNext={goNextNew} name="korekta" placeholder={": "}   />
                        </div> 

                        

                        <div className="filter_controll">   
                                <label>Wys. e-mail: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'0', title: 'Nie'}, {v:'1', title: 'Tak'},      ] }   userData={props.userData} value={filterParam.wys_powiadomienie_email}   valChange={valChangeListener} goNext={goNextNew} name="wys_powiadomienie_email" placeholder={": "}   />
                        </div> 


                        <div className="filter_controll">   
                                <label>Wys. sms: </label>                             
                                <InputCombo items={ [ {v:'_x_', title: '- - - '}, {v:'0', title: 'Nie'}, {v:'1', title: 'Tak'},      ] }   userData={props.userData} value={filterParam.wys_powiadomienie_sms}   valChange={valChangeListener} goNext={goNextNew} name="wys_powiadomienie_sms" placeholder={": "}   />
                        </div>


                         <div className="filter_controll">   
                                <label>E-faktura: </label>                             
                                <InputCombo items={ [{v:'_x_',title:'- - - '}, {v:'0',title:'Nie'}, {v:'1',title:'Tak'},      ] }   userData={props.userData} value={filterParam.efaktura}   valChange={valChangeListener} goNext={goNextNew} name="efaktura" placeholder={": "}   />
                        </div> 


                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > Wystaw fakturę [+]</div>

                              &nbsp;&nbsp;
 

                                
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                                    &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>



               <div className="table_mass">  

                        <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                        &nbsp;

                        <InvoicePrepere userData={props.userData} mainView={props.mainView}  onSuccess={onSuccess}  />

 

                        <InvoiceTempDel userData={props.userData} mainView={props.mainView} selected={arrSelectedToApprove} onSuccess={ onSuccess } />

                        <div className="btn" onClick={scaleDocs}>Scal podobne</div> 

                        <InvoiceApprove userData={props.userData} mainView={props.mainView} selected={arrSelectedToApprove} onSuccess={ onSuccess } />

                        <InvoiceSend userData={props.userData} mainView={props.mainView} selected={arrSelectedApproved} onSuccess={ onSuccess } />

                        <InvoicePrint userData={props.userData} mainView={props.mainView} selected={arrSelectedApproved} onSuccess={ onSuccess } />
                      

                        <span className="btn"   onClick={goZip}  > Spakuj do .ZIP</span>

                        <InvoiceKSeF userData={props.userData} mainView={props.mainView} selected={arrSelectedApproved} onSuccess={ onSuccess }  />

                        {
                                filterParam.fak_kontrahenci_id > 0 &&
                                <InvoiceRaport userData={props.userData} mainView={props.mainView} selected={arrSelectedApproved} onSuccess={onSuccess}  fak_kontrahenci_id={filterParam.fak_kontrahenci_id} />
                        }


               </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  
                                        <table className="table" ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>
                               
                                                <td>Numer</td>                                                                                                                                    
                                                <td>Data</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td>Termin płatności</td>                                                                                                                                    
                                                <td>Netto</td>                                                                                                                                    
                                                <td>Vat</td>                                                                                                                                    
                                                <td>Brutto</td>                                                                                                                                    
                                                <td>Do zapłaty</td>                                                                                                                                    
                                                <td>Kw. rozliczenia</td>                                                                                                                                      
                                                <td >Wys. e-mail</td>                                                                                                                                      
                                                <td className="td_right">Wys. sms</td>                                                                                                                                      
                                                                                                                   
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.zatwierdzona == "0") rowStyle = rowStyle + " color_show3 ";
                                                            if(row.anulowana == "1") rowStyle = rowStyle + " color_deleted ";     
                                                            if(row.po_terminie == "1") rowStyle = rowStyle + " color_deleted2 ";     
                                                            
                                                               var isChecked = "";

                                                            for(var s=0; s<selectedRow.length; s++)
                                                                {
                                                                    if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                }


                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>

                                                            

                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView}>{row.numer_dokumentu}</td>
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView}>{row.data_wystawienia} </td>
                                                                <td> <span  v="review" id={row.id} onClick={changeView}> {row.klient.nazwa} </span>   <sup title="Filtruj, pokaż tylko tego klienta" className="link_normal" field="nazwa" value={row.klient.full} onClick={quickFilter}>[s]</sup> </td>
                                                                <td className="gocenter">{row.termin_platnosci}</td>
                                                                <td className="goright"><FormatDecimal value={row.razem_netto}/></td>
                                                                <td className="goright"><FormatDecimal value={row.razem_vat}/></td>
                                                                <td className="goright"><FormatDecimal value={row.razem_brutto}/></td>
                                                                <td className="goright"><FormatDecimal value={row.do_zaplaty}/></td>
                                                                <td className="goright">
                                                                    <FormatDecimal value={row.kwota_rozliczenia}/>
                                                                    {
                                                                        row._saldo_ != undefined &&
                                                                        <sup className="link_color" v="calc" id={row._saldo_.id} onClick={changeView} >&nbsp;[r]&nbsp;</sup>
                                                                    }
                                                                </td>   

                                                                <td className="gocenter">                                                                       
                                                                           {row.wys_powiadomienie_email == 1 && <span>tak</span>}
                                                                           {row.wys_powiadomienie_email == 0 && <span>nie</span>}      
                                                                           {
                                                                                row.email_info.length > 0 &&
                                                                                <b><sup className="link_color" title={row.email_info}>??</sup></b>
                                                                           }                                                                 
                                                                </td>      
                                                                <td className="gocenter">                                                                       
                                                                           {row.wys_powiadomienie_sms == 1 && <span>tak</span>}
                                                                           {row.wys_powiadomienie_sms == 0 && <span>nie</span>}                                                                       
                                                                </td>                                                             
                                                            
                                                     
                                                            </tr>

                                                    } )
                                                }


                                                 <tr className="tab_sum">                                                                                               
                                                    <td> </td>
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td className="goright gobold"><FormatDecimal value={sumNetto} /></td>                                                                                                                                    
                                                    <td className="goright gobold"><FormatDecimal value={sumVat} /></td>                                                                                                                                   
                                                    <td className="goright gobold"><FormatDecimal value={sumBrutto} /></td>                                                                                         
                                                    <td className="goright gobold"><FormatDecimal value={sumDoZaplaty} /></td>                                                                                          
                                                    <td className="goright gobold"><FormatDecimal value={sumRozliczonych} /></td>                                                                                                                   
                                                                                                                                 
                                                </tr>

                                        </tbody>

                                </table>
                        </div>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>
                                                <td className="link_normal" onClick={changeSelectedAll} >Z</td>
                                                <td>Numer</td>                                                                                                                                    
                                                <td>Numer KSeF</td>                                                                                                                                    
                                                <td>Data</td>     
                                                { props.fak_kontrahenci_id == undefined && <td>Nazwa</td>   }                                                                                                                                                                                    
                                                <td>Termin płatności</td>                                                                                                                                    
                                                <td>Netto</td>                                                                                                                                    
                                                <td>Vat</td>                                                                                                                                    
                                                <td>Brutto</td>                                                                                                                                    
                                                <td>Do zapłaty</td>                                                                                                                                    
                                                <td>Kw. rozliczenia</td>                                                                                                                                      
                                                <td >Wys. e-mail</td>                                                                                                                                      
                                                <td className="td_right">Wys. sms</td>                                                                                                                                      
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(row.zatwierdzona == "0") rowStyle = rowStyle + " color_show3 ";
                                                            if(row.anulowana == "1") rowStyle = rowStyle + " color_deleted ";     
                                                            if(row.po_terminie == "1") rowStyle = rowStyle + " color_deleted2 ";      

                                                            if(row.zatwierdzona == "-10") rowStyle = rowStyle + " color_show4 ";      

                                                            if(row.zatwierdzona == "1" && row.do_zaplaty == row.kwota_rozliczenia ) rowStyle =  " color_show5 ";      
                                                            
                                                               var isChecked = "";

                                                            for(var s=0; s<selectedRow.length; s++)
                                                                {
                                                                    if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                }


                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>

                                                                <td className="gocenter">
                                                                    <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                                </td>  

                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView}>{row.numer_dokumentu}</td>
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView}>
                                                                    {row.ksef_numer}
                                                                    {
                                                                        row.ksef_status != 'brak' &&  row.ksef_numer.length < 2 &&
                                                                        <span style={{color:'#F00', fontWeight:'bold'}}  title={row.ksef_status} >{row.ksef_status}</span>
                                                                    }
                                                                </td>
                                                                <td className="gocenter" v="review" id={row.id} onClick={changeView}>{row.data_wystawienia} </td>

                                                                {
                                                                 props.fak_kontrahenci_id == undefined &&
                                                                <td> <span  v="review" id={row.id} onClick={changeView}> {row.klient.full} </span>   <sup title="Filtruj, pokaż tylko tego klienta" className="link_normal" field="nazwa" value={row.klient.full} onClick={quickFilter}>[s]</sup> </td>
                                                                }    
                                                               

                                                                <td className="gocenter">{row.termin_platnosci}</td>
                                                                <td className="goright"><FormatDecimal value={row.razem_netto}/></td>
                                                                <td className="goright"><FormatDecimal value={row.razem_vat}/></td>
                                                                <td className="goright"><FormatDecimal value={row.razem_brutto}/></td>
                                                                <td className="goright"><FormatDecimal value={row.do_zaplaty}/></td>
                                                                <td className="goright">
                                                                    <FormatDecimal value={row.kwota_rozliczenia}/>
                                                                    {
                                                                        row._saldo_ != undefined &&
                                                                        <sup className="link_color" v="calc" id={row._saldo_.id} onClick={changeView} >&nbsp;[r]&nbsp;</sup>
                                                                    }
                                                                </td>   

                                                                <td className="gocenter">                                                                       
                                                                           {row.wys_powiadomienie_email == 1 && <span>tak</span>}
                                                                           {row.wys_powiadomienie_email == 0 && <span>nie</span>}      
                                                                           {
                                                                                row.email_info.length > 0 &&
                                                                                <b><sup className="link_color" title={row.email_info}>??</sup></b>
                                                                           }                                                                 
                                                                </td>      
                                                                <td className="gocenter">                                                                       
                                                                           {row.wys_powiadomienie_sms == 1 && <span>tak</span>}
                                                                           {row.wys_powiadomienie_sms == 0 && <span>nie</span>}                                                                       
                                                                </td>                                                             
                                                                <MenuTable>
                                                                    <ul>
                                                                        {
                                                                            row.zatwierdzona == 0 &&
                                                                            <li   onClick={ removeInvoice } atr-id ={ row.id } atr-title ={ row.numer_dokumentu }  > Usuń </li>
                                                                        }                                                                                                                                               
                                                                        <li v="review" id={row.id} onClick={changeView}>Szczegóły</li>
                                                                  
                                                                        {
                                                                            row.zatwierdzona == 1 && row.anulowana == 0 &&
                                                                            <Fragment>
                                                                                <li   onClick={ goDownload } atr-id ={ row.id } atr-title ={ row.numer_dokumentu }  > Pobierz </li>
                                                                                <li   onClick={ goInvoiceKor } atr-id ={ row.id } atr-title ={ row.numer_dokumentu }  > Korekta </li>
                                                                            </Fragment>                                                                           
                                                                        }
                                                                         {
                                                                            row.zatwierdzona == 1 && row.anulowana == 0 &&
                                                                           <li   onClick={ goAgain } atr-id ={ row.id } atr-title ={ row.numer_dokumentu }  > Utwórz podobną </li>
                                                                        }

                                                                        {
                                                                            row.zatwierdzona == 1 && row.anulowana == 0 && row.ksef_numer.length < 10 &&
                                                                           <li   onClick={ removeInvoiceZ } atr-id ={ row.id } atr-title ={ row.numer_dokumentu }  > Cofnij wystawienie </li>
                                                                        }
                                                                    </ul>
                                                                </MenuTable>
                                                     
                                                            </tr>

                                                    } )
                                                }


                                                 <tr className="tab_sum">                                                                                               
                                                    <td> </td>
                                                    { props.fak_kontrahenci_id == undefined && <td></td>   }                                                                                                                                   
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td> </td>                                                                                                                                    
                                                    <td className="goright gobold"><FormatDecimal value={sumNetto} /></td>                                                                                                                                    
                                                    <td className="goright gobold"><FormatDecimal value={sumVat} /></td>                                                                                                                                   
                                                    <td className="goright gobold"><FormatDecimal value={sumBrutto} /></td>                                                                                         
                                                    <td className="goright gobold"><FormatDecimal value={sumDoZaplaty} /></td>                                                                                          
                                                    <td className="goright gobold"><FormatDecimal value={sumRozliczonych} /></td>                                                                                                                   
                                                    <td></td>                                                                                  
                                                </tr>

                                        </tbody>

                                </table>

               </div>
 
              

              {dialogSelect}                                  
              {tmpView}

    </div>
}


export default Invoices;